import { useEffect, useState } from 'react';

export function setQueryParamsFromObject(obj: Record<string, any>) {
  const url = new URL(window.location.href);
  const queryParams = new URLSearchParams(url.search);
  for (const key in obj) {
    if (obj[key] !== undefined && obj[key] !== null) {
      queryParams.set(key, String(obj[key]));
    } else {
      queryParams.delete(key);
    }
  }
  const newUrl = `${url.pathname}?${queryParams.toString()}`;
  window.history.replaceState({}, '', newUrl);
}

export function useStateUrl<T extends Record<string, any>>(
  initialState: Partial<T>
) {
  const [state, _setState] = useState(initialState);

  useEffect(() => {
    _setState(initializeStateFromUrl());
  }, []);

  function setState(newState: T) {
    _setState(newState);
    setQueryParamsFromObject(newState);
  }

  function setField<K extends keyof T>(key: K, value: T[K]) {
    const newState = { ...state, [key]: value };
    setState(newState as T);
  }

  function initializeStateFromUrl() {
    const url = new URL(window.location.href);
    const queryParams = new URLSearchParams(url.search);
    const newState: Partial<T> = { ...initialState };
    for (const key in initialState) {
      const value = queryParams.get(key);
      if (value !== null) {
        const initialType = typeof initialState[key];
        if (initialType === 'number') {
          newState[key] = Number(value) as any;
        } else if (initialType === 'boolean') {
          newState[key] = (value === 'true') as any;
        } else {
          newState[key] = value as any;
        }
      }
    }
    return newState;
  }

  return [state, setState, setField] as const;
}
